export function articlesListGet(category, page) {
	return {
    type: 'ARTICLES_LIST_GET',
		payload: {
			category: category,
			page: page,
		},
	}
}

export function articlesItemGet(id) {
	return {
    type: 'ARTICLES_ITEM_GET',
		payload: {
			id: id,
		},
	}
}
